import { render, staticRenderFns } from "./DataCellDate.vue?vue&type=template&id=37a862ba&"
import script from "./DataCellDate.vue?vue&type=script&lang=js&"
export * from "./DataCellDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/normacs_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports